export default __webpack_public_path__ + "static/media/new.b5dcf950.svg";